import { ChartDataContainer } from "./index";

export type SongEarning = {
  title: string;
  artist: string;
  album: string;
  earning: number;
  quantity: number;
  isrc: string;
  upc?: string;
  networkName: string;
}

export type ServiceEarning = {
  name: string;
  earning: number;
  networkName: string;
}

export type Royalties = {
  total: number;
  lastUpdate: Date;
  changes: number;
};

export type Tips = Omit<Royalties, 'changes'> & {
  selectedPeriodTotal: number;
};

export type ChartYear = Record<"thisYear" | "lastYear", ChartDataContainer>;

export type RevenueOverview = {
  total: number,
  topLevelTotal: number,
  totalPrevPeriod: number,
  totalThisPeriod: number,
  totalRecordCount: number,
  updatedAt: string,
  data: Revenue[],
}

export type Revenue = {
  id?: string
  name: string,
  location: string,
  date: string,
  amount: number,

  isReadOnly: boolean, // used for "tips" and "merchandise" api to mark that this record must be readonly
  subRevenues: SubRevenue[]
  merchSource?: MerchSource,
}

export enum MerchSource {
  manual = 'Manual',
  shopify = 'Shopify',
  square = 'Square',
  performance = 'Performance'
}

export type SubRevenue = {
  id?: string
  type: RevenueType,
  name: string,
  amount: number
}

export enum RevenueType {
  Performance = "Performance",
  Merch = "Merch",
  Tips = "Tips"
}